var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-auth-page',{attrs:{"title":"Give your employees flexible pay","subtitle":!_vm.isDisableRegistration
      ? 'Give your employees the flexibility to access, track, build and better manage their pay.'
      : '',"image":_vm.themeImage('login-tablet.png'),"buttons":[
      !_vm.isDisableLandingPageLinks && {
        text: 'Learn More →',
        link: 'https://stream.co/en',
      },
    ].filter(button => !!button)},scopedSlots:_vm._u([(!_vm.isDisablePartnerLogos)?{key:"footer",fn:function(){return [_c('span',{staticClass:"social__label"},[_vm._v("As used by our partners:")]),_c('img',{staticClass:"social__image",attrs:{"src":_vm.socialProofImg}})]},proxy:true}:null],null,true)},[(_vm.loading)?_c('app-loading'):_c('LoginForm',{attrs:{"image":_vm.themeImage('logo.svg')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }